<template>
    <v-dialog v-model="show" @click:outside="close" max-width="600">
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title>
                    Note on Location of Banks
                </v-toolbar-title>
                <v-btn icon class="close" color="white" @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="mt-3">
                <p class="text-center subtitle-2 mb-3 font-weight-bold">
                    Here are some examples to help guide you in selecting the location of your bank.
                </p>
                <ul class="text-left examples">
                    <li>
                        <strong>Example A:</strong> I am in the United States but I want to send money to my brother in Nigeria.
                        <br />
                        Answer: Select United States
                    </li>
                    <li>
                        <strong>Example B:</strong> I am in Ghana but I want to send money from my Canadian bank account to my Ghanaian bank account
                        <br />
                        Answer: Select Canada
                    </li>
                    <li>
                        <strong>Example C:</strong> I am in South Africa and I would like to send money to my son in Germany
                        <br />
                        Answer: Select South Africa
                    </li>
                    <li>
                        <strong>Example D:</strong> I am a student in Italy and I would like to receive money from my sister in Kenya
                        <br />
                        Answer: Select Italy
                    </li>
                    <li>
                        <strong>Example E:</strong> I am in Cameroon and I would like to request money from my aunt in the United Kingdom
                        <br />
                        Answer: Select Cameroon
                    </li>
                    <li>
                        <strong>Example F:</strong> I am in Spain but I want to send money from my bank account in Nigeria to my bank account in Spain
                        <br />
                        Answer: Select Nigeria
                    </li>
                    <li>
                        <strong>Example G:</strong> I am a Freelancer and I want to send money from my Wise GBP account to my bank account in Nigeria
                        <br />
                        Answer: Select United Kingdom
                    </li>
                </ul>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            show: Boolean,
        },
        methods: {
            close() {
                this.$emit('update:show', false);
            },
        },
    };
</script>

<style scoped>
.examples li {
    line-height: 23px;
    margin-bottom: 8px;
    font-size: 16px;
}

.close {
    position: absolute;
    right: 15px;
}
</style>
